import { render, staticRenderFns } from "./AbstractContent.vue?vue&type=template&id=5bf8d82e&scoped=true"
import script from "./AbstractContent.vue?vue&type=script&lang=js"
export * from "./AbstractContent.vue?vue&type=script&lang=js"
import style0 from "./AbstractContent.vue?vue&type=style&index=0&id=5bf8d82e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8d82e",
  null
  
)

export default component.exports